'use client';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import styled from '@emotion/styled';

import ProjectResponseSelectItem from './project-response-select-item';

const SortableContainer = styled.div<{
  transform?: string;
  transition?: string;
}>`
  transform: ${(props) => props.transform || 'none'};
  transition: ${(props) => props.transition};
`;

export default function ProjectResponseRankingItem({
  app,
  value,
  label,
  tag,
  disabled,
  id,
}: Omit<
  React.ComponentProps<typeof ProjectResponseSelectItem>,
  'isDragAndDrop' | 'onClick'
> & { id: string; app?: 'manager' | 'survey' }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  return (
    <SortableContainer
      ref={setNodeRef}
      transform={CSS.Transform.toString(transform)}
      transition={transition}
      {...attributes}
      {...listeners}
      data-disabled={disabled}
      className='flex w-full flex-1 data-[disabled=false]:touch-none'
      data-test='ranking-item'
    >
      <ProjectResponseSelectItem
        app={app}
        value={value}
        tag={tag}
        disabled={disabled}
        isDragAndDrop
        label={label}
      />
    </SortableContainer>
  );
}
